import { inject, Service } from "@angular/core";
import { filter, map } from "rxjs";

import { MainResponseModel } from "../../../shared/models";
import { MainService } from "../../../shared/services/main-service";
import { Adaa4DashboardsSummary } from "../models/adaa4-home-model";

@Service()
export class Adaa4HomeApiService {
  private readonly _mainService = inject(MainService);

  public getSummary() {
    return this._mainService
      .sendRequest<MainResponseModel<Adaa4DashboardsSummary>>({
        method: "GET",
        url: "dashboards-summary/getSummary",
      })
      .pipe(
        filter((res) => !res.inError),
        map((res) => res.responseData ?? {})
      );
  }
}
